export default function AboutUs() {
  return (
    <div className="min-h-screen py-12 px-6 font-sans text-gray-800" dir="rtl">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-xl shadow-md">
        <h1 className="text-3xl font-bold text-green-700 mb-6 text-center">درباره نوویتکس بایند</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6 leading-relaxed">
            شرکت نوویتکس بایند با سال‌ها تجربه در زمینه تولید محصولات تخصصی برای صنعت دام و طیور، 
            همواره در راستای بهبود سلامت دام و افزایش بهره‌وری گام برداشته است.
          </p>
          
          <h2 className="text-2xl font-semibold text-green-600 mt-8 mb-4">تاریخچه شرکت</h2>
          <p className="text-gray-600 mb-6 leading-relaxed">
            نوویتکس بایند در سال ۱۳۹۰ با هدف تولید محصولات با کیفیت برای خنثی‌سازی مایکوتوکسین‌ها 
            تأسیس شد و از آن زمان تاکنون با بهره‌گیری از آخرین فناوری‌های روز دنیا، 
            محصولاتی کارآمد و مطابق با استانداردهای بین‌المللی تولید کرده است.
          </p>
          
          <h2 className="text-2xl font-semibold text-green-600 mt-8 mb-4">ماموریت ما</h2>
          <p className="text-gray-600 mb-6 leading-relaxed">
            ماموریت ما ارائه راهکارهای مؤثر برای جذب و خنثی‌سازی مایکوتوکسین‌ها در خوراک دام و طیور 
            به منظور افزایش سلامت دام، بهبود عملکرد و در نهایت تضمین کیفیت محصولات دامی است.
          </p>
          
          <h2 className="text-2xl font-semibold text-green-600 mt-8 mb-4">تیم ما</h2>
          <p className="text-gray-600 mb-6 leading-relaxed">
            تیم نوویتکس بایند متشکل از متخصصان مجرب در زمینه دامپزشکی، تغذیه دام و فناوری‌های 
            نوین است که همواره در حال تحقیق و توسعه برای ارائه محصولات بهتر و کارآمدتر هستند.
          </p>
        </div>
      </div>
    </div>
  );
}